import { FC } from "react";
import { Box, makeStyles } from "@material-ui/core";

import { ListingTerm } from "components";
import { breakpoints, Desktop, Mobile } from "containers/Responsive";
import { InventoryListing } from "services/inventory/types";

const useStyles = makeStyles(theme => ({
  root: {
    "& > span": {
      fontWeight: theme.typography.fontWeightMedium,
    },
    "& div > span": {
      color: theme.custom.palette.softGray.main,
      [`@media (max-width: ${breakpoints.mobile}px)`]: {
        fontSize: 12,
      },
    },
  },
  listingEarnsThrough: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(0.375, 0),
    "& > div": {
      display: "flex",
      flexDirection: "column",
      marginRight: theme.spacing(0.625),
    },
  },
}));

export interface AssetDetailsProps {
  listing: InventoryListing;
}

const AssetDetails: FC<AssetDetailsProps> = ({ listing }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <span>{listing.title}</span>
      <Box className={classes.listingEarnsThrough}>
        <ListingTerm term={listing.term} />
        {listing.term !== "life_of_rights" && listing.term !== "fixed_return" && (
          <div>
            <Desktop>
              <span>{listing.term_remaining} Years Remaining</span>
            </Desktop>
            <Mobile>
              <span>{listing.term_remaining} Remaining</span>
            </Mobile>
          </div>
        )}
      </Box>
      <div>
        <span>ID: {listing.listing_id}</span>
      </div>
    </Box>
  );
};

export default AssetDetails;
